

















import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwAnnexCount from "./AnnexCount.vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";
import { mapActions } from "vuex";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwAnnexCount: iwAnnexCount,
        iwInputCheckbox: iwInputCheckbox,
    },

    data: function() {
        return {
            pathInStoreAnnexCount: "property.building.annexCount",
            pathInStoreUI: "property.hasOutbuildings",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "COMMERCIAL", "INDUSTRY", "APARTMENT", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },

        annexCount: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreAnnexCount);
        },

        annexCountInput: function(): Vue {
            return (this.$refs.annexCount as Vue).$refs.annexCountInput as Vue;
        },

        hasOutBuildings: {
            get: function(): boolean {
                return this.$store.getters["FormModule/getValueUI"](this.pathInStoreUI);
            },

            set: function(value: boolean) {
                this.$store.commit("FormModule/addValueUI", {
                    path: this.pathInStoreUI,
                    value: value,
                });

                if (value) {
                    // Make sure count is at least 1 when checked.
                    if (!this.annexCount) {
                        this.$store.dispatch("FormModule/addValue", {
                            path: this.pathInStoreAnnexCount,
                            value: 1,
                        });

                        this.annexCountInput.$data.internalValue = 1;
                    }
                } else {
                    // Remove count when unchecked.
                    this.deleteValuePath(this.pathInStoreAnnexCount);
                }
            },
        }
    },

    created: function() {
        this.hasOutBuildings = Boolean(this.annexCount);
    },

    methods: {
        ...mapActions({
            deleteValuePath: "FormModule/deleteValuePath",
        }),
    }
});

